import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import locale from '../locale';
export var uploadFile = function uploadFile(uploadOption) {
  var xhr = new XMLHttpRequest();
  var formData = new FormData(); // init

  uploadOption.fileName = uploadOption.fileName || 'file';

  uploadOption.onError = uploadOption.onError || function () {};

  uploadOption.onSuccess = uploadOption.onSuccess || function () {};

  xhr.open('post', uploadOption.action);

  if (uploadOption.data) {
    _Object$keys(uploadOption.data).forEach(function (key) {
      formData.append(key, uploadOption.data[key]);
    });
  }

  if (uploadOption.file) {
    formData.append(uploadOption.fileName, uploadOption.file);
  }

  if (xhr.upload) {
    xhr.upload.onprogress = function progress(e) {
      if (e.total > 0) {
        // @ts-ignore
        e.percent = e.loaded / e.total * 100;
      } // @ts-ignore


      uploadOption.onProgress(e);
    };
  } // eslint-disable-next-line consistent-return


  xhr.onload = function onload() {
    if (xhr.status < 200 || xhr.status >= 300) {
      //@ts-ignore
      return uploadOption.onError(new Error(locale.lng('Upload.defaultError')));
    }

    var result = xhr.responseText;

    try {
      var resData = JSON.parse(result); //@ts-ignore

      uploadOption.onSuccess(resData);
    } catch (e) {
      //@ts-ignore
      return uploadOption.onError(new Error(locale.lng('Upload.defaultError')));
    }
  };

  xhr.onerror = function error(e) {
    // @ts-ignore
    uploadOption.onError(e);
  };

  if ('withCredentials' in xhr) {
    xhr.withCredentials = !!uploadOption.withCredentials;
  } // 设置请求头


  if (!('X-Requested-With' in uploadOption.header) && uploadOption.header['X-Requested-With'] !== null) {
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  }

  if (uploadOption.header) {
    _Object$keys(uploadOption.header).forEach(function (key) {
      if (uploadOption.header[key] !== undefined) {
        xhr.setRequestHeader(key, uploadOption.header[key]);
      }
    });
  }

  xhr.send(formData);
  return {
    abort: function abort() {
      xhr.abort();
    }
  };
};